import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CreateAccount from "../pages/CreateAccount/CreateAccount";
import Home from "../pages/Home/Home";
import ForgotPassword from "../pages/ForgotPassword/ForgotPassword";
import Dashboard from "../pages/Dashboard/Dashboard";
import Error404 from "../pages/Error404/Error404";
import EditProfile from "../pages/EditProfile/EditProfile";
import PolicyAdvice from "../pages/PolicyAdvice/PolicyAdvice";
import BookAppointment from "../pages/BookAppointment/BookAppointment";
import ListDating from "../pages/ListDating/ListDating";
import ProjectStatusGuard from "../components/ProjectStatusGuard/ProjectStatusGuard";
import TemporaryRedirect from "../components/TemporaryRedirect/TemporaryRedirect";

const Rutas = () => {  


    return (
        <BrowserRouter>        
            <Routes>
                <Route path="/" element={<Home />} />    
                <Route path="/login" element={<Home />} />  
                <Route path="/:projectId" element={<ProjectStatusGuard><Home /></ProjectStatusGuard>} />      
                <Route path="/create-account/:userId" element={<CreateAccount />} />                
                <Route path="/forgot-password" element={<ForgotPassword />} />                
                <Route path={"/:projectId/create/:userId"} element={<ProjectStatusGuard><CreateAccount /></ProjectStatusGuard>} />     
                <Route path="/bh/usuario_1_22" element={<TemporaryRedirect to="https://bh-organizationvcard.vercel.app/" />} />
                <Route path={"/:projectId/:userId"} element={<ProjectStatusGuard><Dashboard /></ProjectStatusGuard>}/>                                                                                                     
                <Route path={"/:projectId/:userId/edit"} element={<ProjectStatusGuard><EditProfile /></ProjectStatusGuard>}/>
                <Route path={"/policy-advice/:projectId/:userId"} element={<ProjectStatusGuard><PolicyAdvice /></ProjectStatusGuard>}/>
                <Route path={"/:projectId/:userId/book-appointment"} element={<ProjectStatusGuard><BookAppointment /></ProjectStatusGuard>}/>
                <Route path={"/:projectId/:userId/list-dating"} element={<ProjectStatusGuard><ListDating /></ProjectStatusGuard>}/>
                <Route path="*" element={<Error404 />} />
            </Routes>        
        </BrowserRouter>
    );
}
export default Rutas;
